<template>
	<div>
		<!-- 基本信息 -->
		<div class="inputList" v-if="isBasic">
			<labelInput :outInput="newform.company_name" :spanRequired="true" normalPlace="请输入单位名称"
			@inputChange="labelInput($event,'company_name')"
				spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="newform.contacts" :spanRequired="true" normalPlace="请输入联系人" 
			@inputChange="labelInput($event,'contacts')"
				spanTitle="联系人" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入联系电话" 
			@inputChange="labelInput($event,'contacts_phone')"
				spanTitle="联系电话" :spanWidth="spanWidth" componentWidth="520px" :isPhone="true" specilType='number'
				:maxLimit="11">
			</labelInput>

			<!-- 主要经营管理指标统计 -->
			<p class="view_head midflex">主要经营管理指标统计</p>
			<labelInput :outInput="newform.output_value" :spanRequired="true" specilType='number' normalPlace="请输入总产值"
				@inputChange="labelInput($event,'output_value')" spanTitle="总产值(万元)" :spanWidth="spanWidth"
				componentWidth="90%">
			</labelInput>
			<labelInput :outInput="newform.contract_amount" :spanRequired="true" specilType='number' normalPlace="请输入合同额"
				@inputChange="labelInput($event,'contract_amount')" spanTitle="合同额(万元)" :spanWidth="spanWidth"
				componentWidth="90%">
			</labelInput>
			<labelInput :outInput="newform.liability_ratio" :spanRequired="true" specilType='number' normalPlace="请输入资产负债率"
				@inputChange="labelInput($event,'liability_ratio')" spanTitle="资产负债率(%)" :spanWidth="spanWidth"
				componentWidth="90%">
			</labelInput>
			<labelInput :outInput="newform.profit_rate" :spanRequired="true" specilType='number' normalPlace="请输入产值利润率"
				@inputChange="labelInput($event,'profit_rate')" spanTitle="产值利润率(%)" :spanWidth="spanWidth"
				componentWidth="90%">
			</labelInput>
			<labelInput  :outInput="newform.growth_rate" :spanRequired="true" specilType='number' normalPlace="请输入净资产增长率"
				@inputChange="labelInput($event,'growth_rate')" spanTitle="净资产增长率(%)" :spanWidth="spanWidth"
				componentWidth="90%">
			</labelInput>

			<!-- 提示 -->
			<div class="allTips" style="color: grey;border: 1px solid #D3D3D3">
				<p>注：以上指标，以会计事务所《审计报告》中的财务数据为依据。</p>
				<p>附：财务指标计算方式</p>


				<div class="tipList">
					<p>序号</p>
					<p>项目指标</p>
					<p>计算公式</p>
				</div>

				<div class="tipList">
					<p>1</p>
					<p>资产负债率(%)</p>
					<p>(负债总额/资产总额)x100%</p>
				</div>

				<div class="tipList">
					<p>2</p>
					<p>产值利润率(%)</p>
					<p>利润总额/企业总产值x100%</p>
				</div>

				<div class="tipList">
					<p>3</p>
					<p>净资产增长率(%)</p>
					<p>[(本年净资产总额/企业总产值)-1]x100%</p>
				</div>

				<div class="tipList">
					<p>4</p>
					<p>社会贡献率(%)</p>
					<p>企业社会贡献总额/平均资产总额x100%</p>
				</div>

				<div class="tipList">
					<p>5</p>
					<p>千人负伤率(%)</p>
					<p>全年重伤人数+轻伤人数/全部职工人数x1000%</p>
				</div>

			</div>

		</div>

		<!-- 获奖信息 -->
		<div class="awardInfo" v-else>
			<p class="view_head midflex">质量获奖情况</p>
			<labelInput :outInput="project_name0" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','0')"
				spanTitle="工程名称1" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name0" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','0')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time0" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','0')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="project_name1" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','1')"
				spanTitle="工程名称2" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name1" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','1')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time1" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','1')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="project_name2" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','2')"
				spanTitle="工程名称3" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name2" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','2')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time2" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','2')" componentWidth="520px">
			</normalPicker>


			<p class="view_head midflex">安全文明情况</p>
			<labelInput :outInput="project_name3" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','3')"
				spanTitle="工程名称1" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name3" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','3')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time3" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','3')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="project_name4" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','4')"
				spanTitle="工程名称2" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name4" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','4')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time4" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','4')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="project_name5" :spanRequired="true" normalPlace="请输入工程名称" 
			@inputChange="labelInput2($event,'project_name','5')"
				spanTitle="工程名称3" :spanWidth="spanWidth" componentWidth="90%">
			</labelInput>
			<labelInput :outInput="award_name5" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','5')"
				spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time5" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','5')" componentWidth="520px">
			</normalPicker>

			<p class="view_head midflex">科技进步奖</p>
			<labelInput :outInput="award_name6" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','6')"
				spanTitle="获奖名称1" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time6" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','6')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="award_name7" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','7')"
				spanTitle="获奖名称2" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time7" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','7')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="award_name8" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','8')"
				spanTitle="获奖名称3" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time8" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','8')" componentWidth="520px">
			</normalPicker>

			<p class="view_head midflex">信用建设奖</p>
			<labelInput :outInput="award_name9" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','9')"
				spanTitle="获奖名称1" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time9" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','9')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="award_name10" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','10')"
				spanTitle="获奖名称2" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time10" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','10')" componentWidth="520px">
			</normalPicker>

			<labelInput :outInput="award_name11" :spanRequired="true" normalPlace="请输入获奖名称" 
			@inputChange="labelInput2($event,'award_name','11')"
				spanTitle="获奖名称3" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="award_time11" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
				@selectDate="labelInput2($event,'award_time','11')" componentWidth="520px">
			</normalPicker>
		</div>
	</div>
</template>

<script>
	import labelInput from '../../../components/table/labelInput.vue'
	import normalPicker from '../../../components/table/normalPicker.vue'
	export default {
		data() {
			return {
				project_name0: '',
				award_name0: '',
				award_time0: '',
				
				project_name1: '',
				award_name1: '',
				award_time1: '',
				
				project_name2: '',
				award_name2: '',
				award_time2: '',
				
				project_name3: '',
				award_name3: '',
				award_time3: '',
				
				project_name4: '',
				award_name4: '',
				award_time4: '',
				
				project_name5: '',
				award_name5: '',
				award_time5: '',
				
				award_name6: '',
				award_time6: '',
				award_name7: '',
				award_time7: '',
				award_name8: '',
				award_time8: '',
				award_name9: '',
				award_time9: '',
				award_name10: '',
				award_time10: '',
				award_name11: '',
				award_time11: '',
				
				spanWidth: '180px',
				newform:{},
				form: {
					company_name: '',
					contacts: '',
					contacts_phone: '',
					output_value: '',
					contract_amount: '',
					liability_ratio: '',
					profit_rate: '',
					growth_rate: '',
				},
			}
		},
		components: {
			labelInput,
			normalPicker
		},
		props: {
			// 切换基本信息和获奖信息
			isBasic: {
				type: Boolean,
				default: true
			},
			basicMsg: {
				type: Object,
				default: () => {
					return {}
				}
			},
			awardMsg: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		watch: {
			basicMsg(newvalue) {
				this.newform = {
					...newvalue
				}
			},
			awardMsg(newvalue) {
				this.project_name0 = newvalue[0].project_name
				this.award_name0 = newvalue[0].award_name
				this.award_time0 = newvalue[0].award_time
				this.project_name1 = newvalue[1].project_name
				this.award_name1 = newvalue[1].award_name
				this.award_time1 = newvalue[1].award_time
				this.project_name2 = newvalue[2].project_name
				this.award_name2 = newvalue[2].award_name
				this.award_time2 = newvalue[2].award_time
				this.project_name3 = newvalue[3].project_name
				this.award_name3 = newvalue[3].award_name
				this.award_time3 = newvalue[3].award_time
				this.project_name4 = newvalue[4].project_name
				this.award_name4 = newvalue[4].award_name
				this.award_time4 = newvalue[4].award_time
				this.project_name5 = newvalue[5].project_name
				this.award_name5 = newvalue[5].award_name
				this.award_time5 = newvalue[5].award_time
				this.award_name6 = newvalue[6].award_name
				this.award_time6 = newvalue[6].award_time
				this.award_name7 = newvalue[7].award_name
				this.award_time7 = newvalue[7].award_time
				this.award_name8 = newvalue[8].award_name
				this.award_time8 = newvalue[8].award_time
				this.award_name9 = newvalue[9].award_name
				this.award_time9 = newvalue[9].award_time
				this.award_name10 = newvalue[10].award_name
				this.award_time10 = newvalue[10].award_time
				this.award_name11 = newvalue[11].award_name
				this.award_time11 = newvalue[11].award_time
			}
		},
		created() {
			if (this.isBasic) {
				this.$emit('basicInfo', this.form)
			}
		},
		methods: {
			labelInput(e, name) {
				this.form[name] = e
				this.$emit('basicInfo', this.form)
			},
			labelInput2(e, name, id) {
				const params = [id, name, e]
				this.$emit('awardInfo', params)
			}
		}
	}
</script>

<style scoped>
	.midflex {
		width: 100%;
		text-align: center;
		margin-bottom: 20px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.awardInfo {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	/* 提示 */
	.allTips {
		margin: 20px 0;
		padding-left: 80px;
		text-align: left;
	}

	.tipList {
		/* margin-left: 80px; */
		display: flex;
		justify-content: flex-start;
	}

	.tipList p {
		display: inline-block;
		text-align: left;
		line-height: 25px;
	}

	.tipList p:nth-child(1) {
		width: 80px;
	}

	.tipList p:nth-child(2) {
		width: 200px;
	}

	.tipList p:nth-child(3) {
		width: 350px;
	}
</style>
